import { all } from 'redux-saga/effects';
import { LanguageSaga } from './LanguageList';
import { CMSDataSaga } from './CMSData';



export default function* rootSaga() {
  yield all([
    LanguageSaga(),
    CMSDataSaga()
  ])
}

